<template>
  <div>
    <a :class="[{hide: showDescription}, 'button alt show-terms hide-for-medium-up']"
       @click="showDescription = !showDescription">
      {{ $t('product-detail.description-show') }}
    </a>

    <div :class="[{hide: !showDescription}, 'product-terms']" v-html="description"/>

    <a :class="[{hide: !showDescription}, 'button alt hide-terms']"
       @click="showDescription = false">
      {{ $t('product-detail.description-hide') }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showDescription: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-detail/Description.vue